import { cn } from '~/utils/cn';

export function StreamingIndicator() {
  return (
    <div className="flex items-center gap-1 py-1" aria-label="Generating response">
      {[0, 1, 2].map((i) => (
        <span
          key={i}
          className={cn(
            'bg-muted-foreground/60 inline-block h-1.5 w-1.5 rounded-full',
            'animate-bounce',
          )}
          style={{ animationDelay: `${String(i * 150)}ms` }}
        />
      ))}
    </div>
  );
}
